import "@hotwired/turbo-rails";
import * as bootstrap from "bootstrap";
import Swal from "sweetalert2";
import "./controllers/guests_index";
import VMasker from "vanilla-masker";
import { initFlashToasts } from "./lib/flash_toasts";

window.Swal = Swal;
window.bootstrap = bootstrap;
window.VMasker = VMasker;

document.addEventListener("turbo:load", () => {
  // Remove qualquer backdrop residual do Bootstrap (modal/offcanvas) que possa ter ficado preso
  document.querySelectorAll(".modal-backdrop, .offcanvas-backdrop").forEach(el => el.remove());
  document.body.classList.remove("modal-open", "offcanvas-open");
  document.body.style.overflow = "";
  document.body.style.paddingRight = "";

  initFlashToasts(Swal);
});
